<template>
  <div>
    <div v-if="verify" class="error-box">
      <div class="error-title">您已同意使用個資建檔，凱基保經及業務員感謝您的確認，如需審視同意文字，請：點擊此處開啟或下載同意書</div>
      <v-btn color="secondary"
           @click="backHandler">
      <v-icon dark
              right>點擊此處開啟或下載同意書</v-icon>
    </v-btn>
    </div>
    <base-error-page v-else :errorMsg="message" ></base-error-page>
  </div>
</template>
<script>
import BaseErrorPage from '@/components/Base/BaseErrorPage';
import store from '@/store';
export default {
  components: { BaseErrorPage },
  data () {
    return {
      message: null, // 錯誤訊息
      verify: false, // 顯示區域
      pram: null,
      url: null,
    }
  },
  beforeRouteEnter (to, from, next) {
    const query = to.query
    // 更新客戶個資同意
    store.dispatch('ins/saveCusAgree', { urlNum: query.pram }).then(r => {
      if (r.data != '') {
        next(vm =>{
          vm.verify = true
          vm.url = r.data
        })
      } else{
        next(vm =>{
          vm.verify = false
          vm.message =  "error" // 顯示錯誤訊息
        })
      }
    })
  },
  created () {
  },

  methods: {
    backHandler () {  // 開啟同意書PDF
      window.open(this.url, "_blank", "noopener,noreferrer");
    }
  },
}
</script>
<style lang="stylus" scoped>
.error-box {
  width: 600px;
  border-radius: 15px;
  margin: auto;
  margin-top: 100px;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.21);
  background-color: #ffffff;
  padding: 50px 70px;
}

.error-title {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-bottom: 30px;
  color: $primary-color;
}

.prompt {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-bottom: 10px;
  color: $primary-color;
}

.p-rel {
  font-size: 14px;
  position: relative;
}
</style>
